import { useState, useEffect } from "react";
import useAuth from "./useAuth";

const useCode = () => {
  const { user } = useAuth();
  const [code, setCode] = useState(user?.code || "");

  // Sync code state with user.code when user changes (e.g., after auto-login)
  useEffect(() => {
    if (user?.code && user.code !== code) {
      setCode(user.code);
    }
  }, [user?.code, code]);

  return {
    code,
    setCode: (code) => {
      setCode(code);
    },
  };
};

export default useCode;
